// Legacy's panzoom capped zoom at 5x the image's natural size (jquery.panzoom's
// default maxScale). react-zoom-pan-pinch scales relative to the size the image
// is laid out at, so a photo fitted to the viewport hits a fixed maxScale long
// before it reaches that many natural pixels.
const LEGACY_MAX_NATURAL_ZOOM = 5;

// Returns the maxScale that lets the viewer reach the legacy zoom depth for this
// image, never lower than the viewer's own baseline.
export function getMaxZoomScale(img: HTMLImageElement, baseMaxScale: number): number
{
  const { naturalWidth, clientWidth } = img;
  if (!naturalWidth || !clientWidth) return baseMaxScale;

  return Math.max(baseMaxScale, (naturalWidth / clientWidth) * LEGACY_MAX_NATURAL_ZOOM);
}
